// @flow
import { get } from 'lodash';
import { PREPARE_BE } from 'Store/booking/proposals/constants';
import { CLEAR_SELECTED_PROPOSAL, SELECT_PROPOSAL } from './selectedProposalId.action';

type State = ?string;
type Payload = Array<Proposal> | { proposalId?: string };

const initialState: State = null;

function selectedProposalIdReducer(state: State = initialState, action: Action<Payload>): State {
  switch (action.type) {
    case PREPARE_BE:
    case SELECT_PROPOSAL:
      return get(action, 'payload.proposalId');

    case CLEAR_SELECTED_PROPOSAL:
      return initialState;

    default:
      return state;
  }
}

export default selectedProposalIdReducer;
